import type { ApiCode } from '@/api/schemas/common'

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: ApiCode,
    public readonly apiMessage: string,
  ) {
    super(apiMessage)
    this.name = 'ApiError'
  }
}
